import React, { FormEvent, useState } from 'react';
import { useTestWebhookUrl } from '../../../hooks/labs/mutations';
import { WebhookModel } from '../../../models/webhook.model';
import { WebhookTypeEnum } from '../../../enums/webhook-type.enum';
import { TemplateTester } from '../molecules/TemplateTester';

type LabsTab = 'webhook' | 'template';

export default function Labs() {
  const [activeTab, setActiveTab] = useState<LabsTab>('webhook');
  const [webhook, setWebhook] = useState<WebhookModel>({ type: WebhookTypeEnum.Template, url: '' });
  const testWebhook = useTestWebhookUrl();

  const testWebhookUrl = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const url = webhook.url.trim();
    if (!url) return;
    await testWebhook.mutateAsync({ ...webhook, url });
  };

  return (
    <div>
      <div className="mb-5 border-b border-gray-700" role="tablist" aria-label="Labs tools">
        <button
          type="button"
          onClick={() => setActiveTab('webhook')}
          className={`step-15 mr-5 border-b-2 px-1 py-3 text-sm font-medium ${
            activeTab === 'webhook'
              ? 'border-blue-500 text-white'
              : 'border-transparent text-gray-400 hover:text-white'
          }`}
          role="tab"
          aria-selected={activeTab === 'webhook'}
        >
          Webhook testing
        </button>
        <button
          type="button"
          onClick={() => setActiveTab('template')}
          className={`step-16 border-b-2 px-1 py-3 text-sm font-medium ${
            activeTab === 'template'
              ? 'border-blue-500 text-white'
              : 'border-transparent text-gray-400 hover:text-white'
          }`}
          role="tab"
          aria-selected={activeTab === 'template'}
        >
          Template testing
        </button>
      </div>

      {activeTab === 'webhook' && (
        <section aria-labelledby="webhook-tester-heading">
          <h2 id="webhook-tester-heading" className="mb-5 text-xl font-bold text-white">
            Template webhook tester
          </h2>
          <form className="mb-5 w-full text-sm step-13" onSubmit={testWebhookUrl}>
            <div className="flex">
              <div className="w-full pr-5">
                <input
                  type="url"
                  placeholder="Webhook URL"
                  required
                  value={webhook.url}
                  onChange={(event) => setWebhook({ ...webhook, url: event.target.value })}
                  className="block w-full rounded-lg border border-gray-300 bg-gray-50 p-2.5 text-sm text-gray-900 dark:bg-gray-700 dark:text-white"
                />
              </div>
              <button
                type="submit"
                className="mr-2 inline-flex items-center rounded-lg bg-blue-700 p-2.5 text-center text-sm font-medium text-white hover:bg-blue-800 focus:outline-none focus:ring-4 focus:ring-blue-300 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
              >
                Test
              </button>
            </div>
          </form>
        </section>
      )}

      {activeTab === 'template' && (
        <section aria-labelledby="template-tester-heading">
          <h2 id="template-tester-heading" className="mb-5 text-xl font-bold text-white">
            Template tester
          </h2>
          <TemplateTester />
        </section>
      )}
    </div>
  );
}
